import React, { useEffect, useRef, useState } from "react";

export default function HorizontalScroll({
  children,
  style,
  contentStyle,
  paddingBottom = 6,
  rightPadding = 32,
  leftPadding = 10, // ✅ bufor na “wystające” elementy KaTeX (pierwiastki/indeksy)
}) {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  // unikalny scope, żeby CSS działał tylko w tym komponencie
  const scopeIdRef = useRef(`hs_${Math.random().toString(36).slice(2, 10)}`);
  const scopeId = scopeIdRef.current;

  useEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) return;

    const check = () => {
      // +2px próg na “prawie równo”
      setHasOverflow(inner.scrollWidth > outer.clientWidth + 2);
    };

    check();

    const ro = new ResizeObserver(check);
    ro.observe(outer);
    ro.observe(inner);

    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={outerRef}
      className={`hscope ${scopeId}`}
      style={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0, // ⭐ nie pozwól rozpychać w flex/grid
        // Gdy jedna oś ma `auto`, CSS oblicza `visible` na drugiej osi jako
        // `auto`. To potrafiło tworzyć pionowy scrollbar od wystających o
        // pojedyncze piksele elementów KaTeX. Przewijamy wyłącznie w poziomie
        // i tylko wtedy, gdy treść rzeczywiście nie mieści się w kontenerze.
        overflowX: hasOverflow ? "auto" : "visible",
        overflowY: hasOverflow ? "hidden" : "visible",
        WebkitOverflowScrolling: "touch",
        paddingBottom: hasOverflow ? paddingBottom : 0,
        ...style,
      }}
    >
      {/* Scoped CSS jak w MaturaExamSnapshotView (.hscroll-inner + katex override) */}
      <style>{`
        .${scopeId} .hs-inner{
          display: block;
          width: 100%;
          min-width: 0;
          white-space: normal;
          overflow-wrap: anywhere;
          word-break: break-word;
          box-sizing: border-box;
        }

        /* ✅ EXACT FIX: nie łamiemy KaTeX-a */
        .${scopeId} .katex,
        .${scopeId} .katex *{
          word-break: normal !important;
          overflow-wrap: normal !important;
          white-space: nowrap !important;
        }

        /* ✅ jak w maturze: nie rób osobnych scrolli wewnątrz katex-display */
        .${scopeId} .katex-display{
          max-width: 100%;
          overflow: visible !important;
        }
        .${scopeId} .katex-display > .katex{
          max-width: none !important;
        }
        .${scopeId} .katex{
          max-width: none !important;
        }
      `}</style>

      <div
        ref={innerRef}
        className="hs-inner"
        style={{
          // “maturalny” bufor + opcjonalny prawy padding gdy jest overflow
          paddingLeft: leftPadding,
          paddingRight: hasOverflow ? rightPadding : 0,
          ...contentStyle,
        }}
      >
        {children}
      </div>
    </div>
  );
}
